import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  cartCount: 0,
  whishlistCount:0
};
const countSlice = createSlice({
  name: 'count',
  initialState: initialState,
  reducers: {
    setCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
    setWhishlistCount: (state, action) => {
      state.whishlistCount = action.payload;
    },
  },
});

export const {setCartCount,setWhishlistCount} = countSlice.actions;
const countReducer = countSlice.reducer;
export default countReducer;
